import z from "zod";

export type WorkflowType =
	| "split-fulfillment-orders"
	| "fulfill-digital-orders"
	| "schedule-fulfillment-orders"
	| "update-message"
	| "update-snapshot"
	| "process-order"
	| "generate-snapshot"
	| "bulk-report"
	| "update-collection"
	| "fetch-fulfillment-orders"
	| "process-batch";

interface WorkflowMessageBase {
	id: string;
	currentStep: number;
	totalSteps: number;
	type: WorkflowType;
}

export interface WorkflowSuccessMessage<T> extends WorkflowMessageBase {
	ok: true;
	data: T;
}

export interface WorkflowErrorMessage extends WorkflowMessageBase {
	ok: false;
	error: string;
	errorReason?: string;
	recoverable: boolean;
}

export type WorkflowMessage<T> = WorkflowSuccessMessage<T> | WorkflowErrorMessage;

export const TriggerResponseSchema = z.discriminatedUnion("ok", [
	z.object({ ok: z.literal(true), workflowRunId: z.string() }),
	z.object({ ok: z.literal(false), error: z.string() }),
]);

export type TriggerResponse = z.infer<typeof TriggerResponseSchema>;
